var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "dice",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 9",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "dice__d8",
    d: "M 2.25 4.5 L 4.5 0.5 L 6.75 4.5 L 4.5 8.5 L 2.25 4.5 L 4.5 0.5 M 2.25 4.5 L 6.75 4.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD8);
export default __webpack_public_path__ + "static/media/d8.74d4613eeadf06446dd6af64e696b56f.svg";
export { ForwardRef as ReactComponent };